import { API_ROUTES } from "@/config/apiRoutes";
import type { CookieConsentRecord } from "@/Utils/Consent/cookieConsent";
import { loggerService, LogTag } from "@/Utils/LoggerService";

/**
 * Sends the consent record to the backend so the organisation keeps a
 * timestamped, server-side proof of consent (GDPR art. 7(1)).
 *
 * Best-effort by design: the visitor's choice is already persisted locally,
 * so a network failure here must never block the UI or surface a toast.
 * This is why it does NOT go through `appFetch` (which toasts on error).
 */
export async function logCookieConsent(
  record: CookieConsentRecord,
): Promise<void> {
  try {
    const response = await fetch(API_ROUTES.cookieConsent.log, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        consent_id: record.id,
        policy_version: record.version,
        analytics: record.preferences.analytics,
        marketing: record.preferences.marketing,
      }),
    });

    if (!response.ok) {
      loggerService.warn(
        LogTag.API,
        "Cookie consent log was rejected by the server",
        response.status,
      );
    }
  } catch (error) {
    loggerService.warn(
      LogTag.API,
      "Cookie consent could not be logged server-side",
      error,
    );
  }
}
